
export interface Competition_POST_PUT {
    //id: number;
    //itemIds: number[];

    name: string | null;
    tag: string | null;
    place: string | null;
    targetParticipant: string | null;
    startTime: number | null; // milliseconds
    endTime: number | null; // milliseconds
    description: string | null;

    maxAge: number | null;
    minAge: number | null;
    deleted: boolean | null;
    paymentMethods: PaymentMethod[];
    imageSrc: string | null;
    oldResultsTags: string[];
}

export enum PaymentMethodE {
    SWISH_AUTO = "SWISH_AUTO",
    SWISH_MAN = "SWISH_MAN",
    DIRECT_MAN = "DIRECT_MAN",
    INVOICE_MAN = "INVOICE_MAN"
}

export interface PaymentMethod {
  paymentMethod: PaymentMethodE;
  feeInSek: number;
  requireManualVerify?: boolean;
}